export const SUBJECT_KINDS = ["user", "email"] as const;

export type SubjectKind = (typeof SUBJECT_KINDS)[number];

export type Subject = { kind: SubjectKind; id: string };

export type Principal =
  | { kind: "user"; userId: string }
  | { kind: "serviceAccount"; serviceAccountId: string };

export function callerSubject(ctx: {
  userId: string;
  principal?: Principal;
  subjectless?: boolean;
}): Subject | undefined {
  return ctx.subjectless || ctx.principal?.kind === "serviceAccount"
    ? undefined
    : { kind: "user", id: ctx.userId };
}
